import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";

export const getTaxExemptionTypes = createAsyncThunk(
  "setting/getTaxExemptionTypes",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `v1/Settings/GetTaxExemptionType`
      );

      return response?.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Error fetching tax exemption types"
      );
    }
  }
);

export const getEntityUseCodes = createAsyncThunk(
  "setting/getEntityUseCodes",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        "v1/settings/refreshAvalaraEntityUseCodes"
      );

      return response?.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Error fetching entity use codes"
      );
    }
  }
);

export const uploadDocument = createAsyncThunk(
  "setting/uploadDocument",
  async ({ payload, onSuccess, onError }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(`v1/document/upload`, payload, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      onSuccess?.(response?.data);
      return response?.data;
    } catch (err) {
      onError?.(err?.response?.data?.message);
      return rejectWithValue(
        err.response?.data?.message || "Error Uploading Document"
      );
    }
  }
);

export const createGeneralNote = createAsyncThunk(
  "setting/createGeneralNote",
  async ({ payload, onSuccess }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        `/v1/System/CreateGeneralNote`,
        payload
      );
      const data = response?.data;
      onSuccess?.(data);
      return data;
    } catch (err) {
      return rejectWithValue(err?.message || "Error Adding Notes");
    }
  }
);

export const getStates = createAsyncThunk(
  "setting/getStates",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `v1/system/getStates?country_ID=${id}`
      );

      return response?.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Error fetching entity use codes"
      );
    }
  }
);

const settingSlice = createSlice({
  name: "setting",
  initialState: {
    taxExemptTypes: [],
    loading: false,
    uploadDocumentLoading: false,
    entityUseCodes: [],
    entityUseCodesLoading: false,
    notesLoading: false,
    states: [],
    statesLoading: false
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getTaxExemptionTypes.pending, (state) => {
        state.loading = true;
      })
      .addCase(getTaxExemptionTypes.fulfilled, (state, action) => {
        state.taxExemptTypes = action.payload;
        state.loading = false;
      })
      .addCase(getTaxExemptionTypes.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(uploadDocument.pending, (state) => {
        state.uploadDocumentLoading = true;
      })
      .addCase(uploadDocument.fulfilled, (state, action) => {
        state.uploadDocumentLoading = false;
      })
      .addCase(uploadDocument.rejected, (state, action) => {
        state.uploadDocumentLoading = false;
      })
      .addCase(getEntityUseCodes.pending, (state) => {
        state.entityUseCodesLoading = true;
      })
      .addCase(getEntityUseCodes.fulfilled, (state, action) => {
        state.entityUseCodes = action.payload;
        state.entityUseCodesLoading = false;
      })
      .addCase(getEntityUseCodes.rejected, (state, action) => {
        state.entityUseCodesLoading = false;
      })
      .addCase(createGeneralNote.pending, (state) => {
        state.notesLoading = true;
      })
      .addCase(createGeneralNote.fulfilled, (state, action) => {
        state.notesLoading = false;
      })
      .addCase(createGeneralNote.rejected, (state, action) => {
        state.notesLoading = false;
      })
      .addCase(getStates.pending, (state) => {
        state.statesLoading = true;
      })
      .addCase(getStates.fulfilled, (state, action) => {
        state.states = action.payload;
        state.statesLoading = false;
      })
      .addCase(getStates.rejected, (state, action) => {
        state.statesLoading = false;
      });
  },
});

export default settingSlice.reducer;
